

export const topics: { [key: string]: string; } = {
    "אחוזים": "שבר",
    "תלת ממד": "גיאומטרייה",
    "אחר": "שעון",
    "מגוון נושאים במספרים שלמים": "שלמים",
    "זיהוי צורות מוסתרות": "גיאומטרייה",
    "חוק הפילוג": "שלמים",
    "גרפים": "עמודות",
    "יישומונים כלליים לאיורים גיאומטריים": "גיאומטרייה",
    "שברים במודלים שונים": "שבר",
    "היקפים": "גיאומטרייה",
    "נושאים נוספים בשברים": "שבר",
    "אלגברה": "אלגברה",
    "מגוון נושאים בגיאומטרייה": "גיאומטרייה",
    "זוויות": "גיאומטרייה",
    "פעולות חשבון במאונך": "שלמים",
    "תרגולים בפעולות החשבון": "שלמים",
    "חילוק בשלמים": "שלמים",
    "פעולות חשבון בשברים": "שבר",
    "שטח משולש": "גיאומטרייה",
    "ציר": "ציר",
    "קנה מידה": "גיאומטרייה",
    "המבנה העשרוני": "שלמים",
    "מספרים עשרוניים": "שבר",
    "משחקים בשברים": "שבר",
    "מעגל": "גיאומטרייה",
    "תכונות מרובעים": "גיאומטרייה",
    "הסתברות": "הסתברות"
}

export const puzzleTopics = [
    "מגוון נושאים במספרים שלמים",
    "נושאים נוספים בשברים",
    "תרגולים בפעולות החשבון",
    "מספרים עשרוניים"
]


export const lessonTopics = [
   "שבר",
   "גיאומטרייה",
   "שעון",
   "נעלמים",
   "שלמים",
   "אלגברה",
   "תובנות מספריות",
   "עמודות",
   "ציר"
]

export const appTopics = [
     "גיאומטרייה",
     "שלמים",
     "שבר",
     "ציר",
     "ציר,מספרים עשרוניים",
     "שיפוע",
     "פונקציות",
     "עמודות",
     "נקודות במערכת צירים",
     "אלגברה",
     "נעלמים",
     "הסתברות",
     "תובנות מספריות",
     "מהירות,זמן,דרך",
     "גימטרייה",
     "שעון"
]